module.exports = __webpack_public_path__ + "media/images/places/arrow-c27a1805390b3e64e4953219b6bf44b4.svg";